
import Vue from 'vue';
import { mdbListGroup, mdbListGroupItem, mdbCardImage, mdbCardText, mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter, mdbContainer, mdbCard, mdbBtn, mdbRow, mdbCol, mdbCardUp, mdbCardAvatar, mdbCardBody, mdbCardTitle, mdbIcon, mdbInput, mdbTbl, mdbTblBody, mdbTblHead } from 'mdbvue';
import navbar from '@/components/navbar.vue';

import store from '../store';

import moment from 'moment';

export default Vue.extend({
  name: 'Cities',
  data: function() {
    return {
        history: store.state.history,
        cities: store.state.cities
    };
  },
  methods: {
    formatDate(date) {
      return moment(date).format('DD MMM YYYY HH:mm');
    },
    goto(chosenCity) {
      this.$router.push({ path: '/result', query: { historyChosenCity: chosenCity }});
    }
  },
    components: {
      mdbContainer,
      navbar,
      mdbCard, 
      mdbBtn,
      mdbRow,
      mdbCol,
      mdbCardUp, 
      mdbCardAvatar, 
      mdbCardBody, 
      mdbCardTitle, 
      mdbIcon,
      mdbInput,
      mdbModal, 
      mdbModalHeader, 
      mdbModalTitle,
      mdbModalBody, 
      mdbModalFooter,
      mdbCardImage,
      mdbCardText,
      mdbTbl,
      mdbTblBody,
      mdbTblHead,
      mdbListGroup, 
      mdbListGroupItem
    },
});
